<script>
	// publication date, IBM Plex Mono — SSR-only text (never inside an island)
	import { dateLabel } from "../../includes/content.js";
	export let content;
	export let pattern = "D MMMM YYYY";
	$: iso = content && content.published_at;
	$: label = dateLabel(iso, pattern);
</script>

{#if label}
	<time class="af-mono af-item__stamp" datetime={iso}>{label}</time>
{/if}
